function getCommunityStats(community, populationFormat = 'standard') {
  const communityStats = [];
  const maxOffer = community.offers?.reduce((total, offer) => (total
    > offer.totalValue ? total : offer.totalValue), 0);
  if (maxOffer) {
    communityStats.push({
      title: 'Programs',
      content: `$${new Intl.NumberFormat().format(maxOffer)}+`,
    });
  }

  if (community.population) {
    communityStats.push({
      title: 'Population',
      content: `${new Intl.NumberFormat(undefined, { notation: populationFormat }).format(community.population)} people`,
    });
  }

  let formattedWeather = '';
  if (community.highTemp && community.lowTemp) {
    formattedWeather = `${community.highTemp} H / ${community.lowTemp} L`;
  } else if (community.highTemp) {
    formattedWeather = `${community.highTemp} H`;
  } else if (community.lowTemp) {
    formattedWeather = `${community.lowTemp} L`;
  }
  if (formattedWeather) {
    communityStats.push({
      title: 'Avg Weather',
      content: formattedWeather,
    });
  }

  return communityStats;
}

export default getCommunityStats;
